import history from '../../util/history'

const hideDetailView = date => {
  if (!history.canGoBack()) {
    if (date) {
      history.push(`/monthly/date/${date}`)
      return true
    }

    history.push('/monthly/')
    return false
  }

  history.goBack()

  return true
}

export default hideDetailView
